import OriginalTemplate from "./original";
import MinimalTemplate from "./minimal";
import DarkHeroTemplate from "./dark-hero";
import HonestBuildTemplate from "./honest-build";
import DarkHeroHeader from "./dark-hero/DarkHeroHeader";
import DarkHeroFooter from "./dark-hero/Footer";
import HonestBuildFooter from "./honest-build/Footer";
import MinimalAboutPage from "./minimal/pages/AboutPage";
import MinimalAntiCheatPage from "./minimal/pages/AntiCheatPage";
import MinimalContactPage from "./minimal/pages/ContactPage";
import MinimalFaqPage from "./minimal/pages/FaqPage";
import MinimalHowItWorksPage from "./minimal/pages/HowItWorksPage";
import MinimalPricingPage from "./minimal/pages/PricingPage";
import MinimalReputationPage from "./minimal/pages/ReputationPage";
import MinimalSupportPage from "./minimal/pages/SupportPage";
import MinimalTrustAndSafetyPage from "./minimal/pages/TrustAndSafetyPage";
import DarkHeroAboutPage from "./dark-hero/pages/AboutPage";
import DarkHeroAntiCheatPage from "./dark-hero/pages/AntiCheatPage";
import DarkHeroFaqPage from "./dark-hero/pages/FaqPage";
import DarkHeroHowItWorksPage from "./dark-hero/pages/HowItWorksPage";
import DarkHeroPricingPage from "./dark-hero/pages/PricingPage";
import DarkHeroReputationPage from "./dark-hero/pages/ReputationPage";
import DarkHeroSupportPage from "./dark-hero/pages/SupportPage";
import DarkHeroTrustAndSafetyPage from "./dark-hero/pages/TrustAndSafetyPage";
import DarkHeroPrivacyPolicyPage from "./dark-hero/pages/PrivacyPolicyPage";
import DarkHeroTermsOfServicePage from "./dark-hero/pages/TermsOfServicePage";
import DarkHeroGDPRPage from "./dark-hero/pages/GDPRPage";
import HonestBuildAboutPage from "./honest-build/pages/AboutPage";
import HonestBuildFaqPage from "./honest-build/pages/FaqPage";
import HonestBuildGDPRPage from "./honest-build/pages/GDPRPage";
import HonestBuildHowItWorksPage from "./honest-build/pages/HowItWorksPage";
import HonestBuildPrivacyPolicyPage from "./honest-build/pages/PrivacyPolicyPage";
import HonestBuildTermsOfServicePage from "./honest-build/pages/TermsOfServicePage";
import HonestBuildTrustAndSafetyPage from "./honest-build/pages/TrustAndSafetyPage";

/**
 * Template Registry — static build-time map of codename → component.
 *
 * To add a new template:
 *  1. Create app/src/components/templates/<codename>/index.js (default export: homepage component)
 *  2. Create app/src/components/templates/<codename>/manifest.json
 *  3. Add one line here
 *  4. Deploy
 *
 * See docs/templates/CREATING_A_TEMPLATE.md for the full guide.
 */
export const TEMPLATE_REGISTRY = {
  original: OriginalTemplate,
  minimal: MinimalTemplate,
  "dark-hero": DarkHeroTemplate,
  "honest-build": HonestBuildTemplate,
};

export const TEMPLATE_HEADER_REGISTRY = {
  "dark-hero": DarkHeroHeader,
  "honest-build": DarkHeroHeader,
};

export const TEMPLATE_FOOTER_REGISTRY = {
  "dark-hero": DarkHeroFooter,
  "honest-build": HonestBuildFooter,
};

export const TEMPLATE_PAGE_REGISTRY = {
  minimal: {
    about: MinimalAboutPage,
    antiCheat: MinimalAntiCheatPage,
    contact: MinimalContactPage,
    faq: MinimalFaqPage,
    howItWorks: MinimalHowItWorksPage,
    pricing: MinimalPricingPage,
    reputation: MinimalReputationPage,
    support: MinimalSupportPage,
    trustAndSafety: MinimalTrustAndSafetyPage,
  },
  "dark-hero": {
    about: DarkHeroAboutPage,
    antiCheat: DarkHeroAntiCheatPage,
    faq: DarkHeroFaqPage,
    howItWorks: DarkHeroHowItWorksPage,
    pricing: DarkHeroPricingPage,
    reputation: DarkHeroReputationPage,
    support: DarkHeroSupportPage,
    trustAndSafety: DarkHeroTrustAndSafetyPage,
    privacy: DarkHeroPrivacyPolicyPage,
    termsOfUse: DarkHeroTermsOfServicePage,
    gdpr: DarkHeroGDPRPage,
  },
  "honest-build": {
    about: HonestBuildAboutPage,
    antiCheat: DarkHeroAntiCheatPage,
    faq: HonestBuildFaqPage,
    howItWorks: HonestBuildHowItWorksPage,
    pricing: DarkHeroPricingPage,
    reputation: DarkHeroReputationPage,
    support: DarkHeroSupportPage,
    trustAndSafety: HonestBuildTrustAndSafetyPage,
    privacy: HonestBuildPrivacyPolicyPage,
    termsOfUse: HonestBuildTermsOfServicePage,
    gdpr: HonestBuildGDPRPage,
  },
};

/**
 * All known codenames — used by the edge API and admin UI to list available templates.
 * Keep in sync with TEMPLATE_REGISTRY keys.
 */
export const KNOWN_CODENAMES = Object.keys(TEMPLATE_REGISTRY);

export function getTemplatePageComponent(codename, pageKey) {
  return TEMPLATE_PAGE_REGISTRY[codename]?.[pageKey] || null;
}

export function getTemplateHeaderComponent(codename) {
  return TEMPLATE_HEADER_REGISTRY[codename] || null;
}

export function getTemplateFooterComponent(codename) {
  return TEMPLATE_FOOTER_REGISTRY[codename] || null;
}
